import { render, staticRenderFns } from "./ReservedSales.vue?vue&type=template&id=631b5e72&scoped=true&"
import script from "./ReservedSales.vue?vue&type=script&lang=ts&"
export * from "./ReservedSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b5e72",
  null
  
)

export default component.exports